import { FadeIn } from "./FadeIn";

const PageHeader = ({ eyebrow, title, description, testId }) => (
  <section className="bg-surface border-b border-navy-100" data-testid={testId}>
    <div className="mx-auto max-w-6xl px-5 sm:px-8 py-14 sm:py-20">
      <FadeIn>
        {eyebrow && (
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-waratah mb-4" data-testid={`${testId}-eyebrow`}>
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-navy max-w-3xl" data-testid={`${testId}-title`}>
          {title}
        </h1>
        {description && (
          <p className="mt-6 text-lg sm:text-xl text-slate-600 leading-relaxed max-w-3xl" data-testid={`${testId}-description`}>
            {description}
          </p>
        )}
      </FadeIn>
    </div>
  </section>
);

export default PageHeader;
